import ConsentBanner from './container'
export { ConsentBanner }
export default ConsentBanner